import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  PostingForm as SharedPostingForm,
  type PostingFormProps as SharedProps,
} from "@chotca/posting-form";
import { AddressPicker } from "@/components/address-picker";

export type {
  PostingFormOutput,
  PostingFormTemplate,
} from "@chotca/posting-form";

// Employer flavor: chevron-back header (router-aware), 4-step layout,
// primary mobile action, secondary desktop submit.
type EmployerProps = Omit<
  SharedProps,
  | "AddressPicker"
  | "onMobileBack"
  | "splitAdvancedStep"
  | "mobileActionVariant"
  | "desktopSubmitVariant"
>;

export function PostingForm(props: EmployerProps) {
  const nav = useNavigate();
  return (
    <SharedPostingForm
      {...props}
      AddressPicker={AddressPicker}
      onMobileBack={() => nav(-1)}
    />
  );
}
